module.exports = __webpack_public_path__ + "static/media/trash-restore-alt.a811e056.svg";